import type { ReactNode } from 'react';

/**
 * Mostra na tela o negrito que o WhatsApp vai aplicar.
 *
 * A assinatura é escrita com a marcação do WhatsApp (`*Angelo* - Suporte`), e é
 * essa string que sai para o cliente. Sem interpretá-la nas prévias do painel, o
 * atendente conferiria o asterisco em vez do resultado — e a prévia deixaria de
 * responder à única pergunta que ela existe para responder: como isso chega do
 * outro lado.
 *
 * Trata só negrito de propósito: é a única marcação que a assinatura usa.
 */
export function renderWhatsappBold(text: string): ReactNode[] {
  return text.split(/\*([^*]+)\*/g).map((part, index) =>
    // Índice ímpar é o que estava entre asteriscos — é como o split com grupo
    // de captura devolve: [antes, capturado, depois, capturado, ...].
    index % 2 === 1 ? <strong key={index}>{part}</strong> : <span key={index}>{part}</span>,
  );
}
